import { useState } from 'react'
import { useTranslation } from '../i18n'
import { ChevronDown, Globe } from 'lucide-react'

export default function LanguageSwitcher({ className = '' }) {
  const { language, changeLanguage } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const handleLanguageChange = async (lang) => {
    if (language !== lang) {
      await changeLanguage(lang)
    }
    setIsOpen(false)
  }

  const languages = [
    { code: 'fr', name: 'Français', flag: 'FR' },
    { code: 'en', name: 'English', flag: 'EN' },
  ]

  const currentLang = languages.find(lang => lang.code === language) || languages[0]

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-[0.22em] font-medium text-white/85 hover:text-[#E8C547] transition-colors"
        title="Change language"
      >
        <Globe size={15} />
        <span>{currentLang.flag}</span>
        <ChevronDown size={13} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute right-0 mt-3 w-44 bg-white border border-[#D5DAE3] shadow-[0_24px_60px_-28px_rgba(27,34,64,0.35)] z-50">
            <div className="px-4 py-2 border-b border-[#D5DAE3]">
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#6B7280]">Langue</span>
            </div>
            {languages.map((lang) => {
              const active = language === lang.code
              return (
                <button
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  className={`w-full px-4 py-3 text-left text-sm transition-colors flex items-center gap-3 ${
                    active
                      ? 'bg-[#F1F3F8] text-[#203a8a] font-semibold'
                      : 'text-[#1B2240] hover:bg-[#F1F3F8] hover:text-[#203a8a]'
                  }`}
                >
                  <span className="text-[10px] uppercase tracking-[0.25em] w-6">{lang.flag}</span>
                  <span className="font-display">{lang.name}</span>
                </button>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}